import { useEffect } from 'react';
import { Stack, useMediaQuery, useTheme } from '@mui/material';
import {
  axios,
  PageLayout,
  PageNames,
  SelectEcosystem,
  useSessionInfo,
  useSessionInfoOnSuccess,
  DEFAULT_ECOSYSTEM_NAME,
  useEcosystemSelectData,
} from '@diana/core';
import { useTranslation } from 'react-i18next';
import { SELECT_ECOSYSTEM_PAGE_NS } from './i18n';

export const SelectEcosystemPage = () => {
  const { breakpoints } = useTheme();
  const { t } = useTranslation(SELECT_ECOSYSTEM_PAGE_NS);
  const onSessionInfoUpdate = useSessionInfoOnSuccess();

  axios.setEnvironment(DEFAULT_ECOSYSTEM_NAME);
  const { data: info, isFetchedAfterMount } = useSessionInfo({ ecosystem: DEFAULT_ECOSYSTEM_NAME });
  const { isInitiallyLoading, hadLastFetch, setSkippedItems, subscriptions, isLoading } =
    useEcosystemSelectData(info);
  const isLargeDevice = useMediaQuery(breakpoints.up('sm'));

  useEffect(() => {
    if (!!info && !isFetchedAfterMount) {
      onSessionInfoUpdate(info);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <PageLayout
      name={PageNames.SELECT_ECOSYSTEM}
      title={t('title')}
      isContentLoading={isInitiallyLoading}
      showOfflineError={false}
    >
      {!isInitiallyLoading ? (
        <Stack alignItems="center" justifyContent="center" width="100%" py={isLargeDevice ? 10 : 5}>
          <SelectEcosystem
            hadLastFetch={hadLastFetch}
            subscriptions={subscriptions}
            isLoading={isLoading}
            setSkippedItems={setSkippedItems}
          />
        </Stack>
      ) : null}
    </PageLayout>
  );
};
